export default "__VITE_ASSET__C8kpoaG4__"